import { Skeleton } from '@mantine/core';

export default function SkeletonLine() {
  return <Skeleton  h={10} w={'100%'} radius={'md'} mb={10}/>;
}